<template>
  <div>
    <news-details :news_id="$route.params.news"/>
    <div class="container">
      <div class="hero">
        <div>
          <button class="button is-link is-size-3 is-rounded" @click="submit">確認しました</button>
        </div>
        <div>
          <router-link :to="{ name: 'driver', params: { group: $route.params.group } }">
            <button class="button is-rounded">戻る</button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- モーダル表示 -->
    <div class="modal" v-bind:class="{'is-active': isModal}">
      <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">確認</p>
          </header>
          <section class="modal-card-body">
            <div v-if="!isErrors && !error.news_id">
              <p class="is-size-3">{{ username }} さん</p>
              <p class="is-size-4">確認しました！</p>
            </div>
            <div v-if="isErrors">
              <p class="has-text-danger">{{ isErrors }}</p>
            </div>
            <div class="h7 is-size-7 has-text-danger" v-show="error.news_id">※不明なエラーが発生しました。リロードして最初から操作を行ってください。</div>
          </section>
          <footer class="modal-card-foot">
            <router-link :to="{ name: 'driver', params: { group: $route.params.group } }">
              <button class="button is-rounded">戻る</button>
            </router-link>
          </footer>
        </div>
    </div>
    <!-- モーダル表示 end -->
  </div>
</template>

<script>
import NewsDetails from '../../components/NewsDetails.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  data: function(){
    return {
      isModal: false,
      disabled: false,
      submitForm: {
        news_id: null,
      },
      error: {
        news_id: null
      }
    }
  },
  mounted(){
    this.submitForm.news_id = this.$route.params.news
  },
  computed: {
    ...mapState({
      apiStatus: state => state.news.apiStatus,
      isErrors(state){
        if(state.news.errorMessages){
          this.disabled = false
        }
        return state.news.errorMessages
      }
    }),
    ...mapGetters({
      username: 'auth/username',
    })
  },
  components: {
    'news-details': NewsDetails
  },
  methods:{
    clearError () {
      this.$store.commit('news/setErrorMessages', null)
    },
    async submit(){
      this.clearError()
      //初期化
      Object.keys(this.error).forEach((key) => {
        this.$set(this.error, key, null)
      })
      if(!this.isValidation()) return false
      this.disabled = true  //ボタンをローディング表示にする
      await this.$store.dispatch('news/readDetials', this.submitForm)
      if(this.apiStatus || this.isErrors){
        this.isModal = true
      }
    },
    close_poupu(){
      //初期化
      this.clearError()
      this.isModal = false
    },
    isValidation() {
      //グループ名のバリデーション
      if(this.submitForm.news_id === ""){
        this.error.news_id = true
        return false
      }
      return true
    },
  },
}
</script>

<style scoped>
  .container {
    text-align: center;
  }
  button {
    min-width: calc(50% - 100px);
    margin: 12px 12px;
  }
</style>